export const navListBaseStyle =
  "flex items-center justify-center px-[30px] py-[10px] h-[54px] border-b-2 border-slate-200 text-navcolor font-semibold hover:opacity-80";
